/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React, { useState } from 'react';
import classNames from 'classnames';
import SubmitButton from '#components/support/buttons/SubmitButton/index.jsx';

const STATUS = {
  NOT_SUBMITTED: 0,
  SUBMITTING: 1,
  SUBMITTED: 2,
};

type Props = {|
  resendInviteAction: Function,
|};

const ResendInviteSubmitButton = ({ resendInviteAction }: Props): Element<'div'> => {
  const [submitStatus, setSubmitStatus] = useState(STATUS.NOT_SUBMITTED);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async () => {
    setSubmitStatus(STATUS.SUBMITTING);
    setErrorMessage('');
    setSuccessMessage('');

    try {
      await resendInviteAction();
      setSubmitStatus(STATUS.SUBMITTED);
      setSuccessMessage('Invitation sent successfully!');
    } catch (error) {
      setErrorMessage('Failed to send invitation. Please try again.');
      setSubmitStatus(STATUS.NOT_SUBMITTED);
      setSuccessMessage('');

      setTimeout(() => {
        setErrorMessage('');
      }, 5000);
    }
  };

  return (
    <div>
      <SubmitButton
        className="resendInvitationBtn"
        color="secondary"
        disabled={submitStatus === STATUS.SUBMITTED}
        submitting={submitStatus === STATUS.SUBMITTING}
        submittingText="Resending Invitation..."
        onClick={handleSubmit}
        type="button"
      >
        Resend Invitation
      </SubmitButton>
      {errorMessage && (
        <span className={classNames('resend-error', 'text-danger', 'mt-2', 'ml-2', 'small')}>
          {errorMessage}
        </span>
      )}
      {successMessage && (
        <span className={classNames('resend-success', 'text-success', 'mt-2', 'ml-2', 'small')}>
          {successMessage}
        </span>
      )}
    </div>
  );
};

export default ResendInviteSubmitButton;
